import { createWalkingMusic } from './full/walk';
import type { SimEvent } from '../sim/state';
import type { EventCall, SfxName } from './sfx';

// The demo gets `full.demo.ts` in this file's place (ADR 0015).
export const FULL_BAR_CALLS: Readonly<Record<string, SfxName>> = {
  orage: 'bossThunder',
  larsen: 'bossFeedback',
};

export const FULL_EVENT_CALLS: Readonly<Partial<Record<SimEvent['type'], EventCall>>> = {
  eclipseBurst: 'skillGong',
  offeringBurnt: (event) =>
    event.type === 'offeringBurnt' ? (event.look === 'fire' ? 'fireBurnt' : 'giantWoken') : null,
};

export const FULL_MUSIC: { readonly festival?: typeof createWalkingMusic } = {
  festival: createWalkingMusic,
};
